import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation syncSystemApiModuleList(
    $data: syncSystemApiModuleListInput!
  ) {
    syncSystemApiModuleList(data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const syncSystemApiModuleListRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.SyncSystemApiModuleListInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_api_module/sync_system_api_module_list',
  async (
  params: {data: TYPES.SyncSystemApiModuleListInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.syncSystemApiModuleList;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const syncSystemApiModuleListSlice = createSlice({
  name: 'sync_system_api_module_list',
  initialState: initialState,
  reducers: {
    syncSystemApiModuleListClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(syncSystemApiModuleListRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      syncSystemApiModuleListRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      syncSystemApiModuleListRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { syncSystemApiModuleListClear } =
syncSystemApiModuleListSlice.actions;

export const syncSystemApiModuleList = createSelector(
  (state: RootState) =>
  state.systemApiModule.syncSystemApiModuleList.result,
  (state: RootState) =>
  state.systemApiModule.syncSystemApiModuleList.error,
  (state: RootState) =>
  state.systemApiModule.syncSystemApiModuleList.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default syncSystemApiModuleListSlice.reducer;